// Module
var code = `<div class="modal-dialog modal-lg" role="document" id="showDataDialog">
    <div class="modal-content">
        <div class="modal-header">
            <button type="button" class="close" data-bind="click: close" aria-hidden="true">
                <i class="icon-cancel"></i>
            </button>
            <h4 class="modal-title" data-bind="text: title"></h4>
        </div>
        <div class="modal-body">
            <div>
                <pre style="max-height: 500px" data-bind="html: inputDataFormatted"></pre>
            </div>
        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-primary" data-bind="click: close">Close</button>
            <button type="button" class="btn btn-default" data-bind="click: copyToClipboard" title="Copy the C# class definition to the clipboard">
                <span class="icon-copy"></span>
                <span>Copy to Clipboard</span>
            </button>
        </div>
    </div>
</div>
`;
// Exports
export default code;